export default "__VITE_ASSET__BeAEM8mh__"